import MGEGAMEActions from './MGEGAMEActions'

export default class MGSLOTActions extends MGEGAMEActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameCode: 'MG-SLOT-313',
      platform: 'MG',
    }

    this.gameName = 'Pocket Ace'
    this.roundIdPrefix = 'AIBQACYATFA3O2IA'
  }
}
